import { render, staticRenderFns } from "./BaseTableMultiple.vue?vue&type=template&id=15437def&scoped=true"
import script from "./BaseTableMultiple.vue?vue&type=script&lang=js"
export * from "./BaseTableMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15437def",
  null
  
)

export default component.exports